import React from "react";
import { COMPANY } from "../mock";

/**
 * Newcon Roofing & Ceiling brand logo
 * Uses the uploaded NRC logo image with the company name beside it.
 */
export function LogoMark({ size = 44 }) {
  return (
    <img
      src={COMPANY.logoUrl}
      alt={`${COMPANY.brand} logo`}
      width={size}
      height={size}
      className="object-contain rounded"
      style={{ width: size, height: size }}
    />
  );
}

export function LogoWordmark({ height = 44, inverted = false }) {
  const primary = inverted ? "#FFFFFF" : "#1B2960";
  const sub = inverted ? "#94A3B8" : "#64748B";
  return (
    <div className="inline-flex items-center gap-3 select-none" style={{ height }}>
      <img
        src={COMPANY.logoUrl}
        alt={`${COMPANY.brand} logo`}
        className="object-contain"
        style={{ height: height * 1.15, width: height * 1.15 }}
      />
      <div className="leading-none">
        <div
          className="display"
          style={{
            fontFamily: "'Barlow Condensed', sans-serif",
            fontWeight: 800,
            fontSize: height * 0.55,
            letterSpacing: "0.02em",
            color: primary,
            lineHeight: 1,
            textTransform: "uppercase",
          }}
        >
          Newcon
        </div>
        <div
          style={{
            fontFamily: "'Inter', sans-serif",
            fontSize: Math.max(9, height * 0.2),
            fontWeight: 700,
            letterSpacing: "0.22em",
            color: "#C9A227",
            marginTop: 4,
            textTransform: "uppercase",
          }}
        >
          Roofing &amp; Ceiling
        </div>
      </div>
    </div>
  );
}

export default LogoWordmark;
